module.exports = __webpack_public_path__ + "img/3-1.45539e85.svg";